import {useEffect, useState} from "react";
import {getFiltersForClients} from "../../services/Administrative/clientsService";

export const useGetClientFilters = () => {
    const [salesreps, setSalesReps] = useState([]);
    const [states, setStates] = useState([]);

    useEffect(() => {
        const fetchClientFilters = async () => {
            try {
                const response:any = await getFiltersForClients();
                setSalesReps(response.salesreps);
                setStates(response.states);
            } catch (error) {
                console.error('Error fetching filters:', error);
            }
        };
        fetchClientFilters();
    }, []);

    return { salesreps, states };
}